namespace TabAurous.Common {
    export interface ProductImportExcelForm {
        FileName: Serenity.ImageUploadEditor;
    }

    export class ProductImportExcelForm extends Serenity.PrefixedContext {
        static formKey = 'Common.ProductImport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductImportExcelForm.init)  {
                ProductImportExcelForm.init = true;

                var s = Serenity;
                var w0 = s.ImageUploadEditor;

                Q.initFormType(ProductImportExcelForm, [
                    'FileName', w0
                ]);
            }
        }
    }
}
